export const getFormattedPrice = (value: number, locale: string, currency: string, cents = true): string => {
  const price = cents ? value / 100 : value;
  return price?.toLocaleString(locale, { style: 'currency', currency });
};
